import C from './constants'

export const setPropertyTablesAction = (values) => (
    {
        type: C.SET_PROPERTY_TABLE_VALUES,
        payload: values
    }
)

export const clearPropertyTablesAction = () => (
    {
        type: C.CLEAR_PROPERTY_TABLE_VALUES
    }
)
